<!-- 
        <div id="prueba" style="text-align: center;">
            <h1><strong>Agrega a todos tus amigos</strong></h1>    
        </div>
                
                <section class="container  mt-5" >
                    <div class="row  rounded" >
                        <div class="col-12 arriba p-3 border rounded">
                            <h3><strong>{{palco.nombre}}</strong></h3>
                        </div>
                        <div class="col-12 border fondoBlancoCliente" >
                            <h5 class="pt-4 pl-4"><strong>Evento: </strong>{{palco?.nombreEvento}}</h5>
                            <h5 class="pl-4"><strong>Localidad: </strong> {{palco.nombre}}</h5>
                            <h5 class="pl-4 "><strong>Palco No:</strong> {{palco.numeroDentroDeEvento}}</h5>
                            <h5 class="pl-4"><strong>Personas por palco:</strong> {{palco.personasMaximas}}</h5>
                            <h5 class="pl-4"><strong>Personas que van a asistir:</strong> {{clientes.length}}</h5>
                            <h5 class="pl-4" ><strong>Precio: </strong>{{palco?.precio + palco?.servicio +palco?.servicioIva|currency:'COP'}}</h5>
                            <h5 class="pl-4 "><strong>Dinero recaudado: </strong> {{palco?.precioParcialPagado |currency:'COP'}}</h5>
                            <div class="progress ml-4 mt-4" *ngIf= "palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">
                                <div class="progress-bar progress-bar-striped bg-warning" role="progressbar" style="width: {{(palco.precioParcialPagado/(palco.precio+palco.servicio+palco.servicioIva))*100}}%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                                    {{(palco.precioParcialPagado/(palco.precio+palco.servicio+palco.servicioIva))*100}}%
                                </div>
                              </div>

                            <div style="text-align: center;" class="progress ml-4 mt-4" *ngIf= "palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva)">
                              <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: {{(palco.precioParcialPagado/(palco.precio+palco.servicio+palco.servicioIva))*100}}%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">100%</div>
                                
                            </div>
                            <div class="mt-4" *ngIf= "palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva)" style="text-align: center;">
                                <h6><strong>Palco Pagado</strong></h6>
                            </div>

                            <div class="mt-4 mb-4" *ngIf= "palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)" style="text-align: center;">
                                <h6><strong>Palco Por Pagar</strong></h6>
                                <h6><strong>Recuerda que cuentas con un plazo de 72 horas para pagar el 100%.</strong></h6>
                            </div>
                            <hr>
                            <div style="text-align: center;" class="mb-4 " *ngIf= "palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">
                            <h4 ><strong>Aportar a la vaca</strong></h4>
                              <hr class="aaaa" >
                             
                            </div>
                            <div class="ml-4" *ngIf= "palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">
                                <h5><strong>Selecciona el valor para aportar</strong></h5> 
                                <select class="float-center ml-4 mb-4" (change)="cambiarTotal()" type="text" class= "form-control "name ="tipo" required="required" style="width: 100px;" [(ngModel)]="porcentaje">
                                    <option value=""> </option>
                                    <option value=10>10%</option>
                                    <option value=20>20%</option>
                                    <option value=30>30%</option>
                                    <option value=40>40%</option>
                                    <option value=50>50%</option>
                                    <option value=60>60%</option>
                                    <option value=70>70%</option>
                                    <option value=80>80%</option>
                                    <option value=90>90%</option>
                                    <option value=100>100%</option>
                                </select>
                                <h5 class="mt-4"><strong>Dinero a Aportar: </strong>{{valorAPagar | currency:'COP'}} </h5>
                            </div>
                            <div style="text-align: center;" class="mt-4 mb-4" *ngIf= "palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">

                               

                                 <form ngNoForm method="post" [action]="url"  *ngIf="palco.id!=null" >
                                    <input name="merchantId" type="hidden" value="{{merchantId}}">
                                    <input name="accountId" type="hidden" value="{{accountId}}">
                                    <input name="description" type="hidden" value="{{descripcion}}">
                                    <input name="referenceCode" type="hidden" value="{{referenceCode}}">
                                    <input name="amount" type="hidden" value="{{valorAPagar}}">
                                    <input name="tax" type="hidden" value="{{tax}}">
                                    <input name="taxReturnBase" type="hidden" value="0">
                                    <input name="currency" type="hidden" value="COP">
                                    <input name="lng" type="hidden" value="es">
                                    <input name="signature" type="hidden" value="{{signature}}">
                                    <input name="test" type="hidden" value="0">
                                    <input name="buyerEmail" type="hidden" value="{{usuario?.correo}}">
                                    <input name="buyerFullName" type="hidden" value="{{usuario?.nombre}}">
                                    <input name="responseUrl" type="hidden" value="{{respuesta}}/eventos/respuesta">
                                    <input name="confirmationUrl" type="hidden" value="{{confirmacion}}">
                                    
                                   <input name="paymentMethods" type="hidden" value="{{metodos}}"> 
                                    
                                    <button name="Submit" class="btn action_button" type="submit"   value="Enviar" style="font-size:16px ;">Pagar</button>
                                    
                                  </form>  
                            </div>
    
                        </div>
                            
                    </div>
                </section>

                <section class="container mt-5">
                    <div class="row">

                        <div class="col-12 arriba p-2 border rounded" *ngIf= "palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva) && palco.personasMaximas < palco.maximoAdiciones">
                            <h3><strong>Compra Adiciones</strong></h3>
                            <h5 class="pl-4 pr-4" style="color:white"> <strong>Puedes comprar maximo {{palco.adiciones}} adiciones</strong></h5> 
                        </div>
                        <div  class="col-12 fondoBlancoCliente border " *ngIf= "palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva)  && palco.personasMaximas < palco.maximoAdiciones">
                           


                            <h5 class="pt-4 pl-4 pr-4"> <strong>Precio por una adición: </strong>{{palco.precioAdicion +palco.servicioAdicion +palco.servicioIvaAdicion |currency:'COP'}}</h5> 
                            

                            <div class="ml-4" >
                                <h5><strong>Selecciona cuantas adiciones desea:</strong></h5> 
                                <select class="float-center ml-4 mb-4" (change)="cambiarTotalAdicion()" type="text" class= "form-control "name ="tipo" required="required" style="width: 100px;"  [(ngModel)]="seleccionAdicion">
                                    <option value=""> </option>
                                    <option *ngFor="let numero of listaAdiciones" value={{numero}}>{{numero}}</option>
                                </select>
                                <h5 class="mt-4"><strong>Costo: </strong>{{valorPagarAdicion | currency:'COP'}} </h5>
                            </div>
                           

   <form   ngNoForm method="post" [action]="url"  *ngIf="palco.id!=null" >
                                <input name="merchantId" type="hidden" value="{{merchantId}}">
                                <input name="accountId" type="hidden" value="{{accountId}}">
                                <input name="description" type="hidden" value="{{descripcion}}">
                                <input name="referenceCode" type="hidden" value="{{referenceCode}}">
                                <input name="amount" type="hidden" value="{{valorPagarAdicion}}">
                                <input name="tax" type="hidden" value="{{taxAdicion}}">
                                <input name="taxReturnBase" type="hidden" value="0">
                                <input name="currency" type="hidden" value="COP">
                                <input name="lng" type="hidden" value="es">
                                <input name="signature" type="hidden" value="{{signature}}">
                                <input name="test" type="hidden" value="0">
                                <input name="buyerEmail" type="hidden" value="{{usuario?.correo}}">
                                <input name="buyerFullName" type="hidden" value="{{usuario?.nombre}}">
                                <input name="responseUrl" type="hidden" value="{{respuesta}}/eventos/respuesta">
                                <input name="confirmationUrl" type="hidden" value="{{confirmacion}}">
                                
                               <input name="paymentMethods" type="hidden" value="{{metodos}}"> 
                                
                                <button name="Submit" class="btn action_button" type="submit"   value="Enviar" style="font-size:16px ;">Pagar</button>
                                
                              </form> 
                           
                        </div>







                        <div class="col-12 arriba p-3 border rounded  mt-5">
                            <h3><strong>Integrantes del palco</strong></h3>
                        </div>
                        <div class="col-12 fondoBlancoCliente border "  *ngFor="let cliente of clientes">
                            <h5 *ngIf="cliente.numeroDocumento == clientes[0].numeroDocumento" class="colorLetras pt-4 pl-4"> <strong>Esta persona es el líder del palco, solo el líder puede agregar o borrar integrantes del palco</strong> </h5>
                            <h5 class="pl-4 pr-4 pt-4"> <strong>Nombre: </strong>{{cliente.nombre}}</h5> 
                           <h5 class="pl-4 pr-4 pt-2"> <strong>{{cliente.tipoDocumento}}: </strong>{{cliente.numeroDocumento}}</h5>
                           <h5 class="pl-4 pr-4 pb-4 pt-2"> <strong>Correo: </strong>{{cliente.correo}}</h5> 
                           <button *ngIf="borrar " class="btn btn-danger mb-3 ml-3"(click)="quitarCliente(cliente.numeroDocumento)"><strong> Eliminar Asistente</strong></button>
                        </div>



                        <div class="col-12 arriba p-3 border rounded mt-5" *ngIf="borrar">
                            <h3><strong>Agrega a tu amigo</strong></h3>
                        </div>

                        <div class="col-12 fondoBlancoCliente border"  *ngIf="borrar">
                           

                            <form (ngSubmit)="!todoForm.invalid && buscarCliente()" class=" mt-3 pl-4 pb-4" #todoForm="ngForm">
        
                                <fieldset class="form-group  ">
                                    <h5 class="colorLetras"> <strong>Para poder agregar a tus amigos al palco deben estar registrados en AllTickets</strong> </h5>
                                    <label for="id"> <h5> <strong> Número Documento </strong> </h5></label>
                                    <input type="number" class= "form-control"name ="id" required="required"  [(ngModel)]="numeroDocumento">
                                </fieldset>    

                        
                            <button class="action_button" type="submit">Buscar</button>
                        </form>                           
                        </div>

                        <div class="col-12 fondoBlancoCliente border" *ngIf="borrar" >
                            
                            <h5 class="pt-4 pl-4 pr-4"> <strong>Nombre: </strong>{{clienteAgregado.nombre}}</h5> 
                            <h5 class="pl-4 pr-4 pt-2">  <strong *ngIf="clienteAgregado.numeroDocumento==null">No Documento: </strong> <strong *ngIf="clienteAgregado.numeroDocumento!=null">{{clienteAgregado.tipoDocumento}}: </strong>{{clienteAgregado.numeroDocumento}}</h5>
                            <h5 class="pl-4 pr-4 pb-4 pt-2"> <strong>Correo: </strong>{{clienteAgregado.correo}}</h5>
                            <button class="action_button m-4"(click)="agregarCliente()" >Agregar Asistente</button>
                        </div>


                    </div>
                    
                </section>  -->





<div id="prueba" style="text-align: center;">
    <h1><strong>Agrega a todos tus amigos</strong></h1>
</div>

<section class="container  mt-5">
    <div class="row  rounded">
        <div class="col-12 arriba p-3 border rounded">
            <h3><strong>{{palco.nombre}}</strong></h3>
        </div>
        <div class="col-12 border fondoBlancoCliente">
            <h5 class="pt-4 pl-4"><strong>Evento: </strong>{{palco?.nombreEvento}}</h5>
            <h5 class="pl-4"><strong>Localidad: </strong> {{palco.nombre}}</h5>
            <h5 class="pl-4 "><strong>Palco No:</strong> {{palco.numeroDentroDeEvento}}</h5>
            <h5 class="pl-4"><strong>Personas por palco:</strong> {{palco.personasMaximas}}</h5>
            <h5 class="pl-4"><strong>Personas que van a asistir:</strong> {{clientes.length}}</h5>
            <h5 class="pl-4"><strong>Precio: </strong>{{palco?.precio + palco?.servicio
                +palco?.servicioIva|currency:'COP'}}</h5>
            <h5 class="pl-4 "><strong>Dinero recaudado: </strong> {{palco?.precioParcialPagado |currency:'COP'}}</h5>
            <div class="progress ml-4 mt-4"
                *ngIf="palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">
                <div class="progress-bar progress-bar-striped bg-warning" role="progressbar"
                    style="width: {{(palco.precioParcialPagado/(palco.precio+palco.servicio+palco.servicioIva))*100}}%"
                    aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                    {{(palco.precioParcialPagado/(palco.precio+palco.servicio+palco.servicioIva))*100}}%
                </div>
            </div>

            <div style="text-align: center;" class="progress ml-4 mt-4"
                *ngIf="palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva)">
                <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                    style="width: {{(palco.precioParcialPagado/(palco.precio+palco.servicio+palco.servicioIva))*100}}%"
                    aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">100%</div>

            </div>
            <div class="mt-4" *ngIf="palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva)"
                style="text-align: center;">
                <h6><strong>Palco Pagado</strong></h6>
            </div>

            <div class="mt-4 mb-4" *ngIf="palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)"
                style="text-align: center;">
                <h6><strong>Palco Por Pagar</strong></h6>
                <h6><strong>Recuerda que cuentas con un plazo de 120 horas para pagar el 100%.</strong></h6>
            </div>
            <hr>
            <div style="text-align: center;" class="mb-4 "
                *ngIf="palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">
                <h4><strong>Aportar a la vaca</strong></h4>
                <hr class="aaaa">

            </div>
            <div class="ml-4" *ngIf="palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">
                <h5><strong>Selecciona el valor para aportar</strong></h5>
                <select class="float-center ml-4 mb-4" (change)="cambiarTotal()" type="text" class="form-control "
                    name="tipo" required="required" style="width: 100px;" [(ngModel)]="porcentaje">
                    <option value=""> </option>
                    <option value=10>10%</option>
                    <option value=20>20%</option>
                    <option value=30>30%</option>
                    <option value=40>40%</option>
                    <option value=50>50%</option>
                    <option value=60>60%</option>
                    <option value=70>70%</option>
                    <option value=80>80%</option>
                    <option value=90>90%</option>
                    <option value=100>100%</option>
                </select>
                <h5 class="mt-4"><strong>Dinero a aportar: </strong>{{valorAPagar | currency:'COP'}} </h5>
            </div>
            <div style="text-align: center;" class="mt-4 mb-4"
                *ngIf="palco.precioParcialPagado!=(palco.precio+palco.servicio+palco.servicioIva)">

                <!-- <button class="btn action_button" *ngIf="palco.id!=null"  (click)="epaycoPalcosUsuarios()" >
                                            Pagar</button> -->
                <form method="post" id="myForm" #myForm="ngForm" (ngSubmit)="payment()">
                    <input name="merchant_id" type="hidden" value="1163">
                    <input name="form_id" type="hidden" value="{{terminal}}">
                    <input name="terminal_id" type="hidden" value="907">
                    <input name="order_number" type="hidden" id="codigoO" [(ngModel)]="codigoOrden">
                    <input name="amount" type="hidden" value="{{valorAPagar}}">
                    <input name="currency" type="hidden" value="COP">
                    <input name="order_description" type="hidden" value="{{descripcion}}">
                    <input name="client_email" type="hidden" value="{{usuario.correo}}">
                    <input name="client_firstname" type="hidden" value="{{usuario.nombre}}">
                    <input name="client_numdoc" type="hidden" value="{{usuario.numeroDocumento}}">
                    <input name="response_url" type="hidden" value="{{respuesta}}/eventos/respuesta">
                    <input class="btn action_button btnAplicar2" name="Submit" type="submit" value="Pagar">
                </form>


            </div>

        </div>

    </div>
</section>

<section class="container mt-5">
    <div class="row">

        <div class="col-12 arriba p-2 border rounded"
            *ngIf="palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva) && palco.personasMaximas < palco.maximoAdiciones">
            <h3><strong>Compra Adiciones</strong></h3>
            <h5 class="pl-4 pr-4" style="color:white"> <strong>Puedes comprar maximo {{palco.adiciones}}
                    adiciones</strong></h5>
        </div>
        <div class="col-12 fondoBlancoCliente border "
            *ngIf="palco.precioParcialPagado==(palco.precio+palco.servicio+palco.servicioIva)  && palco.personasMaximas < palco.maximoAdiciones">





            <h5 class="pt-4 pl-4 pr-4"> <strong>Precio por una adición: </strong>{{palco.precioAdicion
                +palco.servicioAdicion +palco.servicioIvaAdicion |currency:'COP'}}</h5>


            <div class="ml-4">
                <h5><strong>Selecciona cuantas adiciones deseas:</strong></h5>
                <select class="float-center ml-4 mb-4" (change)="cambiarTotalAdicion()" type="text"
                    class="form-control " name="tipo" required="required" style="width: 100px;"
                    [(ngModel)]="seleccionAdicion">
                    <option value=""> </option>
                    <option *ngFor="let numero of listaAdiciones" value={{numero}}>{{numero}}</option>
                </select>
                <h5 class="mt-4"><strong>Costo: </strong>{{valorPagarAdicion | currency:'COP'}} </h5>
            </div>
            <!-- <button class="btn action_button"  *ngIf="palco.id!=null"  (click)="epaycoPalcosUsuariosAdicion()">
                                        Pagar</button> -->

            <form method="post" id="myForm2" #myForm="ngForm" (ngSubmit)="payment2()">
                <input name="merchant_id" type="hidden" value="1163">
                <input name="form_id" type="hidden" value="{{terminal}}">
                <input name="terminal_id" type="hidden" value="907">
                <input name="order_number" type="hidden" id="codigoO2" [(ngModel)]="codigoOrden">
                <input name="amount" type="hidden" value="{{valorPagarAdicion}}">
                <input name="currency" type="hidden" value="COP">
                <input name="order_description" type="hidden" value="{{descripcion}}">
                <input name="client_email" type="hidden" value="{{usuario.correo}}">
                <input name="client_firstname" type="hidden" value="{{usuario.nombre}}">
                <input name="client_numdoc" type="hidden" value="{{usuario.numeroDocumento}}">
                <input name="response_url" type="hidden" value="{{respuesta}}/eventos/respuesta">
                <input class="btn action_button btnAplicar2" name="Submit" type="submit" value="Pagar">
            </form>
        </div>

        <section *ngIf="cargando">
            <div class="container-fluid contendor-spinner-2">
                <div class="spinner"></div>
            </div>
        </section>





        <div class="col-12 arriba p-3 border rounded  mt-5">
            <h3><strong>Integrantes del palco</strong></h3>
        </div>
        <div class="col-12 fondoBlancoCliente border " *ngFor="let cliente of clientes">
            <h5 *ngIf="cliente.numeroDocumento == clientes[0].numeroDocumento" class="colorLetras pt-4 pl-4">
                <strong>Esta persona es el líder del palco, solo el líder puede agregar o borrar integrantes del
                    palco</strong> </h5>
            <h5 class="pl-4 pr-4 pt-4"> <strong>Nombre: </strong>{{cliente.nombre}}</h5>
            <h5 class="pl-4 pr-4 pt-2"> <strong>{{cliente.tipoDocumento}}: </strong>{{cliente.numeroDocumento}}</h5>
            <h5 class="pl-4 pr-4 pb-4 pt-2"> <strong>Correo: </strong>{{cliente.correo}}</h5>
            <button *ngIf="borrar " class="btn btn-danger mb-3 ml-3"
                (click)="quitarCliente(cliente.numeroDocumento)"><strong> Eliminar Asistente</strong></button>
        </div>



        <div class="col-12 arriba p-3 border rounded mt-5" *ngIf="borrar">
            <h3><strong>Agrega a tu amigo</strong></h3>
        </div>

        <div class="col-12 fondoBlancoCliente border" *ngIf="borrar">


            <form (ngSubmit)="!todoForm.invalid && buscarCliente()" class=" mt-3 pl-4 pb-4" #todoForm="ngForm">

                <fieldset class="form-group  ">
                    <h5 class="colorLetras"> <strong>Para poder agregar a tus amigos al palco deben estar registrados en
                            AllTickets</strong> </h5>
                    <label for="id">
                        <h5> <strong> Número Documento </strong> </h5>
                    </label>
                    <input type="number" class="form-control" name="id" required="required"
                        [(ngModel)]="numeroDocumento">
                </fieldset>


                <button class="action_button" type="submit">Buscar</button>
            </form>
        </div>

        <div class="col-12 fondoBlancoCliente border" *ngIf="borrar">

            <h5 class="pt-4 pl-4 pr-4"> <strong>Nombre: </strong>{{clienteAgregado.nombre}}</h5>
            <h5 class="pl-4 pr-4 pt-2"> <strong *ngIf="clienteAgregado.numeroDocumento==null">No Documento: </strong>
                <strong *ngIf="clienteAgregado.numeroDocumento!=null">{{clienteAgregado.tipoDocumento}}:
                </strong>{{clienteAgregado.numeroDocumento}}</h5>
            <h5 class="pl-4 pr-4 pb-4 pt-2"> <strong>Correo: </strong>{{clienteAgregado.correo}}</h5>
            <button class="action_button m-4" (click)="agregarCliente()">Agregar Asistente</button>
        </div>


    </div>

</section>